import React from "react";
import { useTranslation } from "react-i18next";
import { color } from "../../styles/theme";

const Footer = () => {
  const { t } = useTranslation("layout");
  return (
    <footer style={s.footer}>
      <span style={s.text}>© {new Date().getFullYear()} {t("footer.tagline")}</span>
      <span style={s.version}>v1.0.0</span>
    </footer>
  );
};

const s = {
  footer: {
    display: "flex", alignItems: "center", justifyContent: "center",
    padding: "10px 24px", background: color.gray900, borderTop: "1px solid rgba(255,255,255,0.06)", flexShrink: 0,
  },
  text: { fontSize: 12, color: "#6b7280" },
  version: { fontSize: 11, color: "#4b5563", marginLeft: 10 },
};

export default Footer;
